import { graphql } from 'gatsby'
import { useState } from 'react';

import Layout from '../../../components/layout'
import Seo from '../../../components/seo'
import EstimationHero from '../../../components/EstimationHero';
import Contact from '../../../components/Contact';
import Benefits from '../../../components/Benefits';
import { TrustPilotBig } from '../../../components/TrustPilot/Trustbox';
import Steps from '../../../components/Steps';
import DoubleImageText from '../../../components/TextImages/DoubleImageText';
import Text from '../../../components/TextImages/Text';
import TextImage from '../../../components/TextImages/TextImage';
import { SELLING_PRODUCT_FORM_ROUTE } from '../../../utils/routes/const';
import { JsonLd } from 'react-schemaorg';
import { IndividualProduct } from 'schema-dts';

const EstimationPage = ({data}) => {
  const { watch } = data
  const [isThirdOpen, setIsThirdOpen] = useState(true);

  if (typeof window === 'undefined') {
    return null;
  }

  if (watch.valuation === null) {

    window.location.href = window.location.href.replace('valoracion', 'formulario');
  }

  return (
    <Layout bgColor='bg-white' footerColor={`${isThirdOpen ? 'bg-gray' : 'bg-white'}`} hasStickyChildren>
      <Seo title={`${watch.brand} ${watch.model} (${watch.referenceNumber})`.trim()} />
        <JsonLd<IndividualProduct>
          item={{
            '@context': 'https://schema.org',
            '@type': 'IndividualProduct',
            name: `${watch.brand} ${watch.model} (${watch.referenceNumber})`.trim(),
            brand: watch.brand,
            model: watch.model,
            sku: watch.referenceNumber,
          }}
        />
      <EstimationHero watch={watch} isThirdOpen={isThirdOpen} setIsThirdOpen={setIsThirdOpen} />
      <div className={`${isThirdOpen ? 'block' : 'hidden'}`}>
        <TextImage
          title='sell.textimage.1.title'
          subtitle='sell.textimage.1.subtitle'
          image={data.textImage}
          url='/servicios'
          description='sell.textimage.1.description'
          withTrustLogo
          />
        <Text />
        <DoubleImageText />
        <Contact
          url={SELLING_PRODUCT_FORM_ROUTE(watch.slug)}
          />
        <Steps />
        <TrustPilotBig />
        <Benefits />
        <Contact />
      </div>
    </Layout>
  )
}

export default EstimationPage

export async function config() {
  const { data } = graphql`
    {
      watches: allWatch(filter: {valuation: {ne: 0}}) {
        nodes {
          slug
        }
      }
    }
  `

  const watches = new Set(data.watches.nodes.map(watch => watch.slug));

  return ({ params }) => ({
      defer: watches.has(params.slug)
    })
}


export const query = graphql`
  query($language: String!, $slug: String!) {
    watch: watch(slug: { eq: $slug }) {
      id
      slug
      brand
      model
      referenceNumber
      watchInfo
      watchId
      marketValueFrom
      marketValueTo
      chrono24Cost
      preciseAppraisal
      revision
      shippingCost
      watchprojectCost
      retailPrice
      valuation
      tax
    }
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    textImage: file(base: {eq: "textimage.jpg"}) {
      base
      childImageSharp {
        gatsbyImageData(
          avifOptions: {lossless: true}
        )
      }
  	}
  }
`
